//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const MatchConvertor = require('@/tbs/model/vo/Match')
const MatchManagerConvertor = require('@/tbs/model/vo/MatchManager')
const MatchSignupConfigConvertor = require('@/tbs/model/vo/MatchSignupConfig')
const MatchRuleConvertor = require('@/tbs/model/vo/MatchRule')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchSignupPaymentMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchSignupPaymentMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchSignupPaymentMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleDataLoaded: function() {
        console.log('handleDataLoaded')
        if (this._bridge.isDetail()) {
            const matchId = this.target().matchSignup.matchId
            this.loadMatchGroupByMatch(matchId)
            this.loadMatchInfo(matchId)
        }
    },
    loadMatchGroupByMatch(matchId) {
        console.log('loadMatchGroupByMatch', matchId)
        const self = this
        self.loadViewObjectData(new MatchManagerConvertor, {id: matchId}, function(data) {
            console.log('loadMatchSignupConfig', data)
            self.loadMatchRule(data.match.matchGroupId)
            self.loadMatchSignupConfig(data.match.matchGroupId)
        }, 'manage')
    },
    loadMatchRule: function(matchGroupId) {
        console.log('loadMatchRule', matchGroupId)
        const self = this
        self.loadViewObjectData(
            new MatchRuleConvertor, 
            {matchGroupId: matchGroupId}, 
            function(data) {
                console.log('loadMatchRule', data)
                self.target().matchRule = data.match
            })
    },
    loadMatchSignupConfig: function(matchGroupId) {
        console.log('loadMatchSignupConfig', matchGroupId)
        const self = this
        self.loadViewObjectData(new MatchSignupConfigConvertor, {matchGroupId: matchGroupId}, function(data) {
            console.log('loadMatchSignupConfig', data)
            self.target().matchSignupConfig = data
        })
    },
    loadMatchInfo: function(matchId) {
        console.log('loadMatchInfo', matchId)
        const self = this
        self.loadViewObjectData(new MatchConvertor, {id: matchId}, function(data) {
            console.log('loadMatchInfo', data)
            self.target().match = data
        })
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchSignupPaymentMediator, BaseMediator);

module.exports = tbs_controller_MatchSignupPaymentMediator